import {client} from "@/store";
import Vue from "vue";

export default {
	namespaced: true,

	state: {
		project_markers: [],
		projects: [],
	},

	// sync actions
	mutations: {
		setProjectMarkers(state, value) {
			Vue.set(state, 'project_markers', [...value]);
		},

		setProjects(state, data) {
			const userAgent = navigator.userAgent || navigator.vendor || window.opera;
			let device = "other";
			if (/android/i.test(userAgent)) {
				device = "Android";
			}
			data = data.map(project => {
				project.phone = null;
				project.locationUrl = null;
				if(project.company == null || project.company === false) {
					return project;
				}
				if (project.company.phone != null && project.company.phone.trim() !== "") {
					project.phone = project.company.phone;
				} else {
					project.phone = project.company.mobile;
				}
				if (project.company.visitingaddress_lat != null && project.company.visitingaddress_lat.trim() !== "" && project.company.visitingaddress_lng != null && project.company.visitingaddress_lng.trim() !== "") {
					// open geo intent on android, otherwise open google maps
					if(device === "Android") {
						project.locationUrl = `geo:?q=${project.company.visitingaddress_street}+${project.company.visitingaddress_streetnumber},${project.company.visitingaddress_zipcode}+${project.company.visitingaddress_city}`;
					} else {
						project.locationUrl = ` https://maps.google.com/maps?q=${project.company.visitingaddress_street}+${project.company.visitingaddress_streetnumber},${project.company.visitingaddress_zipcode}+${project.company.visitingaddress_city}`;
					}

				}
				switch (project.company.gripp_salutation_id) {
					case "1":
						project.company.salutation = "Dhr.";
						break;
					case "2":
						project.company.salutation = "Mevr.";
						break;
					default:
						project.company.salutation = "Dhr / Mevr.";
						break;
				}
				return project;
			});
			state.projects = data;
		},

		updateProjectMarker(state, value) {
			state.project_markers = [
				...state.project_markers.filter(item => item.id !== value.id),
				value
			];
			Vue.set(state, 'project_markers', [...state.project_markers]);
		},

		removeProjectMarker(state, markerId) {
			Vue.set(state, 'project_markers', state.project_markers.filter(item => item.id !== markerId));
		}
	},
	getters: {
		getProjectMarkerById: state => id => {
			return state.project_markers.find(item => item.id === id);
		}
	},

	// async actions
	actions: {
		fetchProjectMapMarkers({ commit, state, dispatch }, data) {
			const markersQuery = `
				query ($filter: String, $afterDate: String, $search: String, $filterType: String, $historicFromDate: String, $historicTillDate: String, $appointmentType: String, $vansFilter: [Int]) {
					projectMarkers(filter: $filter, afterDate: $afterDate, search: $search, filterType: $filterType, historicFromDate: $historicFromDate, historicTillDate: $historicTillDate, appointmentType: $appointmentType, vansFilter: $vansFilter) {
						id,
						visitingaddress_lng,
						visitingaddress_lat,
						coordinates,
						color,
						mainProjectLineAmount,
						company {
							id,
							companyname,
							salutation,
							initials,
							infix,
							lastname,
							mobile,
							phone,
							email,
							visitingaddress_street,
							visitingaddress_streetnumber,
							visitingaddress_zipcode,
							visitingaddress_city
						}
					}
				}
			`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(markersQuery, { ...data }).then(result => {
					commit('setIdle', null, { root: true });
					commit('setProjectMarkers', result.projectMarkers);
					resolve(result.projectMarkers);
				});
			});
		},

		refreshProjectMapMarker({ commit, state, dispatch }, data) {
			const markersQuery = `
				query ($id: Int!) {
					projectById(id: $id) {
						id,
						visitingaddress_lng,
						visitingaddress_lat,
						coordinates,
						color,
						company {
							id,
							companyname,
							salutation,
							initials,
							infix,
							lastname,
							mobile,
							phone,
							email,
							visitingaddress_street,
							visitingaddress_streetnumber,
							visitingaddress_zipcode,
							visitingaddress_city
						}
					}
				}
			`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(markersQuery, { ...data }).then(result => {
					commit('setIdle', null, { root: true });
					commit('updateProjectMarker', result.projectById);
					resolve(result.projectMarkers);
				});
			});
		},

		getProjectById({ commit, state, dispatch }, data) {
			const projectQuery = `
			query ($id: Int!, $product_ids: [Int!]) {
				projectById(id: $id, product_ids: $product_ids) {
					id,
					name,
					number,
					visitingaddress_lng,
					visitingaddress_lat,
					coordinates,
					gripp_projectphase_id,
					startdate,
					customfield_uitvoerendeploeg,
					customfield_uitvoeringdatum,
					customfield_begintijduitvoering2,
					customfield_eindtijduitvoering2,
					customfield_uitvoeringnotitie,
					customfield_uitvoeringafspraakgoogle,
					customfield_extrabusuitvoeringdatum,
					customfield_extrabusuitvoeringbegintijd2,
					customfield_extrabusuitvoeringeindtijd2,
					customfield_extrabusuitvoeringbus,
					customfield_extrabusuitvoeringafspraakgoogle,
					customfield_ventilatieroostersuitvoeringdatum,
					customfield_ventilatieroostersuitvoeringbegintijd2,
					customfield_ventilatieroostersuitvoeringeindtijd2,
					customfield_ventilatieroostersuitvoeringbus,
					customfield_uitvoeringventilatieroostersgoogle,
					customfield_impregnerenuitvoeringdatum,
					customfield_impregnerenuitvoeringbegintijd2,
					customfield_impregnerenuitvoeringeindtijd2,
					customfield_impregnerenuitvoeringbus,
					customfield_uitvoeringimpregnerengoogle,
					customfield_hoogwerkeruitvoeringdatum,
					customfield_hoogwerkeruitvoeringcheck,
					customfield_uitvoeringserviceeindtijd2,
					customfield_uitvoeringservicebegintijd2,
					customfield_uitvoeringservicedatum,
					customfield_uitvoeringserviceploeg,
					customfield_supportnotitie,
					customfield_uitvoeringsupportgoogle,
					customfield_supportextradatum,
					customfield_supportextrabegintijd,
					customfield_supportextraeindtijd,
					customfield_supportextraploeg,
					customfield_supportextragoogle,
					customfield_supporthoogwerker,
					customfield_supportbevestigdpeinemann,
					projectLines {
						id,
						searchname,
						amount,
						unit,
						product_id
					},
					company {
						id,
						salutation,
						customernumber,
						companyname,
						phone,
						mobile,
						email,
						initials,
						firstname,
						lastname,
						infix,
						visitingaddress_street,
						visitingaddress_streetnumber,
						visitingaddress_zipcode,
						visitingaddress_city,
						customfield_afspraakdatum,
						customfield_afspraaktijdstip,
						customfield_afspraakwoningtype,
						customfield_opmerkingafspraak,
						customfield_datumaantafel,
						agent {
							display_name
						}
					},
					lastTimeline {
						date, 
						message
					},
					additionalProjects {
						id,
						name,
						projectLines {
							amount,
							unit,
							product_id						
						}
					},
					appointments {
						id,
						type,
						user_id,
						date,
						planned_start_time,
						planned_end_time,
						deleted_at,
						teamLeader, {
							display_name
						},
						teamMembers, {
							display_name
						},
						historicTeamMembers {
							display_name
						},
						causeSupportTickets {
							id,
							type,
							resolving_scope,
							phase,
							reason,
							remark,
							support_actions_description,
							invoice_on_hold,
							resolved_at,
							resolved_remarks,
							resolve_appointment_id,
							created_at,
							deleted_at,
							cancellation_data
						},
						resolveSupportTickets {
							id,
							type,
							resolving_scope,
							phase,
							reason,
							remark,
							support_actions_description,
							invoice_on_hold,
							resolved_at,
							resolved_remarks,
							resolve_appointment_id,
							created_at,
							deleted_at,
							cancellation_data
						},
						created_at,
						createdByUser {
							display_name
						}
					},
					additionalData {
						project_type,
						product_type,
						extra_hoogwerker_date
					},
					supportTickets {
						id,
						type,
						resolving_scope,
						phase,
						reason,
						remark,
						support_actions_description,
						invoice_on_hold,
						resolved_at,
						resolved_remarks,
						resolve_appointment_id,
						created_at,
						deleted_at,
						cancellation_data
					}
				}
			}`;
			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(projectQuery, data).then(result => {
					commit('setIdle', null, { root: true });
					resolve(result.projectById);
				});
			});
		},

		cancelUitvoering({ commit, state, dispatch }, data) {
			const query = `
			mutation ($id: ID!, $reason: String!, $reschedule: Boolean!) {
				cancelUitvoering(id: $id, reason: $reason, reschedule: $reschedule)
			}`;

			return new Promise((resolve, reject) => {
				client.query(query, { ...data }).then(result => {
					if(result.errors != null && result.errors.length > 0) {
						reject(result.errors);
						return;
					}
					resolve(result);
				}).catch((error) => {
					reject(error);
				});
			});
		},

		createGeenGehoor({ commit, state, dispatch }, data) {
			const query = `
			mutation ($id: ID!) {
				createGeenGehoor(id: $id)
			}`;

			return new Promise((resolve, reject) => {
				client.query(query, { id: data }).then(result => {
					if(result.errors != null && result.errors.length > 0) {
						reject(result.errors);
						return;
					}
					resolve(result);
				}).catch((error) => {
					reject(error);
				});
			});
		},

		reassignProject({ commit, state, dispatch }, data) {
			const query = `
			mutation ($id: ID!, $userId: ID!) {
				reassignProject(id: $id, userId: $userId)
			}`;

			return new Promise((resolve, reject) => {
				client.query(query, data).then(result => {
					if(result.errors != null && result.errors.length > 0) {
						reject(result.errors);
						return;
					}
					resolve(result);
				}).catch((error) => {
					reject(error);
				});
			});
		},

		updateProject({ commit, state, dispatch }, data) {
			const query = `
				mutation ($id: ID!, $customfield_hoogwerkeruitvoeringcheck: Boolean, $customfield_supportbevestigdpeinemann: Boolean) {
					updateProject(id: $id, customfield_hoogwerkeruitvoeringcheck: $customfield_hoogwerkeruitvoeringcheck, customfield_supportbevestigdpeinemann: $customfield_supportbevestigdpeinemann)
				}
			`;

			return new Promise((resolve, reject) => {
				client.query(query, { ...data }).then(result => {
					if(result.errors != null && result.errors.length > 0) {
						reject(result.errors);
						return;
					}
					resolve(result);
				}).catch((error) => {
					reject(error);
				});
			});
		}
	}
};
